import { render } from "./PPPSuitabilityTab.vue?vue&type=template&id=f92e6dac&scoped=true"
import script from "./PPPSuitabilityTab.vue?vue&type=script&lang=js"
export * from "./PPPSuitabilityTab.vue?vue&type=script&lang=js"

import "./PPPSuitabilityTab.vue?vue&type=style&index=0&id=f92e6dac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f92e6dac"]])

export default __exports__